import {
    GeneralInformationNodeModel,
    BalanceInformationNodeModel,
    EntryCodeNodeModel,
    InputBaseModel,
    InputModelWithSource
} from '../models';

export default class InstanceUtils {
    static isInput(value: unknown): value is InputBaseModel {
        return value instanceof InputBaseModel;
    }

    static isInputWithSource(value: unknown): value is InputModelWithSource {
        return value instanceof InputModelWithSource;
    }

    static isGeneralInformationNode(value: unknown): value is GeneralInformationNodeModel {
        return value instanceof GeneralInformationNodeModel;
    }

    static isBalanceInformationNode(value: unknown): value is BalanceInformationNodeModel {
        return value instanceof BalanceInformationNodeModel;
    }

    static isEntryCodeNode(value: unknown): value is EntryCodeNodeModel {
        return value instanceof EntryCodeNodeModel;
    }
}
